import { NavTab } from 'components';
import React, { Fragment, useState } from 'react';
import TransferBIDVInternal from './transferBIDVInternal';
import TransferBIDVFast from './transferBIDVFast';
import TransferBIDVStandard from './transferBIDVStandard';

enum Tab {
  INTERNAL = 'Nội bộ BIDV',
  FAST = 'Chuyển nhanh 247',
  STANDARD = 'Chuyển thường',
}

const tabData = {
  [Tab.INTERNAL]: {
    component: TransferBIDVInternal,
  },
  [Tab.FAST]: {
    component: TransferBIDVFast,
  },
  [Tab.STANDARD]: {
    component: TransferBIDVStandard,
  },
};

const TabTransferToBankByBIDVFeature = (): JSX.Element => {
  const [currentTab, setCurrentTab] = useState<string>(Tab.INTERNAL);

  const handleChangeTab = (value: string) => {
    setCurrentTab(value);
  };

  const Component: any = tabData?.[currentTab as Tab]?.component || Fragment;

  return (
    <>
      <NavTab onChange={handleChangeTab} data={Object.keys(tabData)} />
      <Component />
    </>
  );
};

export default TabTransferToBankByBIDVFeature;
